import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { HttpService } from '@services/http.service';
import { EndpointParams } from '@models/utils/endpoint-params';
import { FeeWithType, ProrateSearch } from '@models/index';
import { PaymentProrate } from '@models/prorate/payment-prorate';

@Injectable({
    providedIn: 'root'
})
export class FeeService extends HttpService {
    private readonly defaultEndpointParams: EndpointParams = { app: 'payments', version: 1 };

    searchType(idFee: string): Observable<FeeWithType> {
        return this.get(`fee/member/type/${idFee}`, this.defaultEndpointParams);
    }

    searchPublicType(idFee: string, publicToken: string): Observable<FeeWithType> {
        const params = new HttpParams({ fromString: `centerToken=${publicToken}` });

        return this.get(`public/fee/type/${idFee}`, this.defaultEndpointParams, params);
    }

    getProrateData(prorateSearch: ProrateSearch): Observable<PaymentProrate> {
        return this.post('payments/recurrentfee/prorate', this.defaultEndpointParams, prorateSearch);
    }
}
